import moment from 'moment'

export default function () {
    function formatNumberToEnglish(num) {
        const n = parseInt(num)

        if (isNaN(n) || n < 0) {
            throw 'Invalid number'
        }

        if (n === 0) return 'Zero'.toLowerCase()

        const SINGLE_DIGIT = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine']
        const DOUBLE_DIGIT = [
            'Ten',
            'Eleven',
            'Twelve',
            'Thirteen',
            'Fourteen',
            'Fifteen',
            'Sixteen',
            'Seventeen',
            'Eighteen',
            'Nineteen'
        ]
        const BELOW_HUNDRED = ['Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']

        function translate(n) {
            let word = ''
            if (n < 10) {
                word = SINGLE_DIGIT[n] + ' '
            } else if (n < 20) {
                word = DOUBLE_DIGIT[n - 10] + ' '
            } else if (n < 100) {
                let rem = translate(n % 10)
                word = BELOW_HUNDRED[(n - (n % 10)) / 10 - 2] + ' ' + rem
            }
            return word
        }

        return translate(n).toLowerCase().trim()
    }

    function formatCreditCardNumInput(e, cc) {
        if (e.key === 'Backspace' || e.key === 'Delete') {
            // handle condition to return true in caller so event can continue
            return false
        }

        if (cc) {
            cc = cc.replace(/[^0-9 ]/g, '')

            let inputLen = cc.length

            if (inputLen === 4) {
                cc = cc + ' '
            }
            if (inputLen === 9 && cc[0] !== '3') {
                cc = cc + ' '
            }
            if (inputLen === 11 && cc[0] === '3') {
                cc = cc + ' '
            }
            if (inputLen === 14 && cc[0] !== '3') {
                cc = cc + ' '
            }

            if (inputLen === 15 && !/\s/.test(cc)) {
                cc = cc.substring(0, 4) + ' ' + cc.substring(4, 10) + ' ' + cc.substring(10, 15)
            }

            if (inputLen === 16 && !/\s/.test(cc)) {
                cc =
                    cc.substring(0, 4) +
                    ' ' +
                    cc.substring(4, 8) +
                    ' ' +
                    cc.substring(8, 12) +
                    ' ' +
                    cc.substring(12, 16)
            }
        }

        return cc
    }

    function _phoneNumberIgnore(e) {
        const ctrlDown = e.ctrlKey || e.metaKey

        // validation continue conditions
        if (
            e.key === undefined || // mouse event
            e.key === 'Tab' ||
            (ctrlDown &&
                (e.key === 'c' || // copy
                    e.key === 'v' || // paste
                    e.key === 'z' || // undo
                    e.key === 'y' || // redo
                    e.key === 'l' || // browser address bar
                    e.key === 'r')) // browser refresh
        )
            return false

        // preventDefault conditions
        return /[a-zA-Z!@#$%^&*_=+=\-()|\\[\]{}"':;?><.,~/ ]/.test(e.key)
    }

    function formatPhoneNumberInput(e, phone) {
        if (e.key === 'Backspace' || e.key === 'Delete') {
            return phone
        } else if (_phoneNumberIgnore(e)) {
            e.preventDefault()
            return phone
        }

        if (phone) {
            phone = phone.replace(/[^0-9().+-]/g, '')

            let inputLen = phone.length

            if (inputLen === 1 && phone !== '(') {
                phone = '(' + phone
            }
            if (inputLen === 4) {
                phone = phone + ')'
            }
            if (inputLen === 8) {
                phone = phone + '-'
            }
            if (inputLen === 10 && /[0-9]{10}/.test(phone)) {
                phone =
                    phone.substring(0, 0) +
                    '(' +
                    phone.substring(0, 3) +
                    ')' +
                    phone.substring(3, 6) +
                    '-' +
                    phone.substring(6)
            }
            if (inputLen === 11 && /[0-9]{3}-[0-9]{7}/.test(phone)) {
                phone = phone.replaceAll('-', '')
                phone =
                    phone.substring(0, 0) +
                    '(' +
                    phone.substring(0, 3) +
                    ')' +
                    phone.substring(3, 6) +
                    '-' +
                    phone.substring(6)
            }
            if (inputLen === 12 && /[0-9]{3}-[0-9]{3}-[0-9]{4}/.test(phone)) {
                phone = phone.replaceAll('-', '')
                phone =
                    phone.substring(0, 0) +
                    '(' +
                    phone.substring(0, 3) +
                    ')' +
                    phone.substring(3, 6) +
                    '-' +
                    phone.substring(6)
            }
            if (inputLen === 14 && /\([0-9]{3}\) [0-9]{3}-[0-9]{4}/.test(phone)) {
                phone = phone.replaceAll(' ', '')
                return
            }
            if (inputLen === 15 && /\+[0-9]\.[0-9]{3}\.[0-9]{3}\.[0-9]{4}/.test(phone)) {
                phone = phone.replaceAll('.', '').replace(/\+[0-9]/, '')
                phone =
                    phone.substring(0, 0) +
                    '(' +
                    phone.substring(0, 3) +
                    ')' +
                    phone.substring(3, 6) +
                    '-' +
                    phone.substring(6)
            }
            if (inputLen === 15 && /\+[0-9]\([0-9]{3}\)[0-9]{3}-[0-9]{4}/.test(phone)) {
                phone = phone.replace(/\+[0-9]/, '')
            }
        }

        return phone
    }

    function formatExpDate(e, date) {
        if (e.key === 'Backspace' || e.key === 'Delete') {
            return date
        }

        if (date) {
            date = date.replace(/[^0-9/]/g, '')
            let inputLen = date.length

            if (inputLen === 2) {
                date = date + '/'
            }
        }

        return date
    }

    function formatNumberInput(e, num) {
        if (['e', 'E', '+', '-'].includes(e.key)) {
            e.preventDefault()

            return num
        } else return num
    }

    function formatBigNumbers(num) {
        num = parseInt(num)

        if (num <= 0 || isNaN(num)) {
            return 'N/A'
        }

        const formatter = new Intl.NumberFormat('en', {
            notation: 'compact',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
        })

        return formatter.format(num)
    }

    function formatTimeString(time, { duration, space } = { duration: null, space: false }) {
        if (moment(time, 'h:mm A').toString() === 'Invalid date') throw 'Invalid date'

        const separator = `${space ? ' ' : ''}-${space ? ' ' : ''}`

        return duration
            ? `${moment(time, 'h:mm A').format('h:mmA')}${separator}${moment(time, 'h:mm A')
                  .add(duration, 'hours')
                  .format('h:mmA')}`
            : moment(time, 'h:mm A').format('h:mmA')
    }

    function resolveFormattedDate(formattedDate) {
        const date = formattedDate.split(' ')
        const month = date[0]
        const day = date[1]
        const year = date[2]
        return `${month} ${_appendDateSuffix(day)} ${year}`
    }

    function _appendDateSuffix(day) {
        day = parseInt(day)

        let j = day % 10,
            k = day % 100

        if (j == 1 && k != 11) {
            return day + 'st'
        }
        if (j == 2 && k != 12) {
            return day + 'nd'
        }
        if (j == 3 && k != 13) {
            return day + 'rd'
        }
        return day + 'th'
    }

    return {
        formatNumberToEnglish,
        formatPhoneNumberInput,
        formatCreditCardNumInput,
        formatExpDate,
        formatNumberInput,
        formatBigNumbers,
        formatTimeString,
        resolveFormattedDate
    }
}
